import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c46c8958"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  key: 0,
  class: "component-main"
}
const _hoisted_3 = {
  key: 0,
  class: "component-prefix"
}
const _hoisted_4 = { class: "component-ttype" }
const _hoisted_5 = {
  key: 1,
  class: "component-suffix"
}
const _hoisted_6 = { key: 1 }
const _hoisted_7 = {
  key: 0,
  class: "component-prefix"
}
const _hoisted_8 = { class: "component-ttype" }
const _hoisted_9 = {
  key: 0,
  class: ""
}
const _hoisted_10 = {
  key: 1,
  class: "component-suffix"
}

import { creditRulesOptions } from '../creditRulesDict';
import { RuntimeModel } from '@kunlun/dependencies';
import { forEach } from 'lodash-es';
import { computed, onMounted, reactive, ref, watch } from 'vue';


// 定义 props 类型并设置默认值
interface IProps {
  value: string;
  placeholder: string;
  change: (val: any) => void;
}
enum ValueType {
  Object = 'Object',
  Arrry = 'Arrry'
}

export default /*#__PURE__*/_defineComponent({
  __name: 'FormO2MFieldCombination',
  props: {
    value: { default: '' },
    placeholder: null,
    change: { type: Function, default: () => {} }
  },
  setup(__props: any) {

const props = __props as { value: string, placeholder: string, change: (val: any) => void }


const useNumberFiled = [''];
const viewDsl = ref<any>(undefined);
const changeValue = () => {
  if (viewDsl.value.valueType === ValueType.Object) {
    let obj: any = {};
    for (const item of viewDsl.value?.listData) {
      const key = item.fieldBind as string;
      obj[key] = item[key];
      if (!obj[key] && obj[key] !== 0 && item.ttype !== 'Radio') {
        obj[key] = item['defaultValue'];
      }
    }
    props.change(obj);
  } else {
    let arr: any = [];
    for (const itemObj of viewDsl.value?.listData) {
      let obj: any = {};
      for (const item of itemObj) {
        const key = item.fieldBind as string;
        obj[key] = item[key];
        if (!obj[key] && obj[key] !== 0 && item.ttype !== 'Radio') {
          obj[key] = item['defaultValue'];
        }
      }
      arr.push(obj);
    }
    props.change(arr);
  }
};

const SelectChange = (e: any) => {
  changeValue();
};

watch(
  () => props.placeholder,
  () => {
    if (props.placeholder !== '请选择' && props.placeholder !== '逾期记录' && props.placeholder !== '配送车辆') {
      const currentData = JSON.parse(props.placeholder ?? '');
      if (currentData!.valueType === ValueType.Arrry && currentData?.listData) {
        const grouped = currentData.listData.reduce((accumulator, currentValue) => {
          // 如果 accumulator 中还没有 currentValue.sign 这个键，则创建它并初始化为一个空数组
          if (!accumulator[currentValue.sign]) {
            accumulator[currentValue.sign] = [];
          }
          // 将 currentValue 添加到对应的数组中
          accumulator[currentValue.sign].push(currentValue);
          return accumulator;
        }, {});

        // 将对象转换为二维数组
        const defaultItem = Object.values(grouped);
        defaultItem?.forEach((outSideItem) => {
          (outSideItem as any).forEach((item) => {
            if (!item[item.fieldBind]) {
              item[item.fieldBind] = item.defaultValue;
            }
          });
        });
        currentData.listData = defaultItem;
      } else if (currentData!.valueType === ValueType.Object) {
        const defaultList = currentData.listData;
        defaultList.forEach((item) => {
          if (!item[item.fieldBind]) {
            item[item.fieldBind] = item.defaultValue;
          }
        });
        currentData.listData = defaultList;
      }
      viewDsl.value = currentData;
    }
  },
  { deep: true, immediate: true }
);
//只在运行一下 初始化数值
const once = ref<boolean>(true);
watch(
  () => props.value,
  () => {
    if (viewDsl.value?.listData?.length && !!props?.value?.length && once.value) {
      if (viewDsl.value?.valueType === ValueType.Object) {
        for (const item of viewDsl.value?.listData) {
          item[item?.fieldBind] = props.value[0][item?.fieldBind];
        }
      } else if (viewDsl.value?.valueType === ValueType.Arrry) {
        viewDsl.value?.listData?.forEach((item, index) => {
          item.forEach((it, i) => {
            if (props.value?.[index]?.[it?.fieldBind]) {
              it[it?.fieldBind] = props.value?.[index]?.[it?.fieldBind];
            }
          });
        });
      }
      once.value = false;
    }
  },
  { deep: true, immediate: true }
);

return (_ctx: any,_cache: any) => {
  const _component_a_input_number = _resolveComponent("a-input-number")!
  const _component_a_radio = _resolveComponent("a-radio")!
  const _component_a_radio_group = _resolveComponent("a-radio-group")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_input = _resolveComponent("a-input")!

  return (_openBlock(), _createElementBlock("div", null, [
    (viewDsl.value?.listData?.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          (viewDsl.value.valueType === ValueType.Object)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(viewDsl.value?.listData, (item) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "component-content",
                    key: item?.rowIndex
                  }, [
                    (!!item.prefix)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(item.prefix), 1))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_4, [
                      (item.ttype === 'String')
                        ? (_openBlock(), _createBlock(_component_a_input_number, {
                            key: 0,
                            disabled: !!item.disabled,
                            placeholder: item.placeholder,
                            value: item[item.fieldBind],
                            "onUpdate:value": ($event: any) => ((item[item.fieldBind]) = $event),
                            onChange: changeValue,
                            min: 0,
                            style: {"width":"100%"}
                          }, null, 8, ["disabled", "placeholder", "value", "onUpdate:value"]))
                        : (item.ttype === 'Radio')
                          ? (_openBlock(), _createBlock(_component_a_radio_group, {
                              key: 1,
                              onChange: changeValue,
                              value: item[item.fieldBind],
                              "onUpdate:value": ($event: any) => ((item[item.fieldBind]) = $event),
                              disabled: !!item.disabled,
                              name: "radioGroup"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_a_radio, { value: true }, {
                                  default: _withCtx(() => [
                                    _createTextVNode("限制")
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_a_radio, { value: false }, {
                                  default: _withCtx(() => [
                                    _createTextVNode("不限制")
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 2
                            }, 1032, ["value", "onUpdate:value", "disabled"]))
                          : (item.ttype === 'Select')
                            ? (_openBlock(), _createBlock(_component_a_select, {
                                key: 2,
                                class: "oio-select component-select",
                                disabled: !!item.disabled,
                                options: _unref(creditRulesOptions)[item.OptionEnum] ?? [],
                                style: {"min-width":"220px"},
                                "dropdown-class-name": "oio-select-dropdown",
                                onChange: SelectChange,
                                value: item[item.fieldBind],
                                "onUpdate:value": ($event: any) => ((item[item.fieldBind]) = $event),
                                placeholder: item.placeholder ?? '请选择'
                              }, null, 8, ["disabled", "options", "value", "onUpdate:value", "placeholder"]))
                            : _createCommentVNode("", true)
                    ]),
                    (item.suffix)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(item.suffix), 1))
                      : _createCommentVNode("", true)
                  ]))
                }), 128))
              ]))
            : (viewDsl.value.valueType === ValueType.Arrry)
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(viewDsl.value.listData, (arrItem, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: index,
                      class: "component-main",
                      style: {"padding-bottom":"10px"}
                    }, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(arrItem, (item) => {
                        return (_openBlock(), _createElementBlock("div", {
                          class: _normalizeClass(item.prefix?.length > 9 ? 'component-content-lang' : 'component-content'),
                          key: item?.rowIndex
                        }, [
                          (!!item.prefix)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(item.prefix), 1))
                            : _createCommentVNode("", true),
                          _createElementVNode("div", _hoisted_8, [
                            (item.ttype === 'String')
                              ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                                  (item.fieldBind === 'standard')
                                    ? (_openBlock(), _createBlock(_component_a_input, {
                                        key: 0,
                                        disabled: !!item.disabled,
                                        onChange: changeValue,
                                        value: item[item.fieldBind],
                                        "onUpdate:value": ($event: any) => ((item[item.fieldBind]) = $event),
                                        style: {"width":"100%"},
                                        type: item.fieldBind === 'standard' ? 'string' : item?.iptType ?? 'number',
                                        placeholder: item.placeholder
                                      }, null, 8, ["disabled", "value", "onUpdate:value", "type", "placeholder"]))
                                    : (_openBlock(), _createBlock(_component_a_input_number, {
                                        key: 1,
                                        disabled: !!item.disabled,
                                        placeholder: item.placeholder,
                                        value: item[item.fieldBind],
                                        "onUpdate:value": ($event: any) => ((item[item.fieldBind]) = $event),
                                        onChange: changeValue,
                                        min: 0,
                                        style: {"width":"100%"}
                                      }, null, 8, ["disabled", "placeholder", "value", "onUpdate:value"]))
                                ]))
                              : (item.ttype === 'Radio')
                                ? (_openBlock(), _createBlock(_component_a_radio_group, {
                                    key: 1,
                                    disabled: !!item.disabled,
                                    onChange: changeValue,
                                    value: item[item.fieldBind],
                                    "onUpdate:value": ($event: any) => ((item[item.fieldBind]) = $event),
                                    name: "radioGroup"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_a_radio, { value: true }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(item.fieldBind === 'lostCredit' ? '是' : '限制'), 1)
                                        ]),
                                        _: 2
                                      }, 1024),
                                      _createVNode(_component_a_radio, { value: false }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(item.fieldBind === 'lostCredit' ? '否' : '不限制'), 1)
                                        ]),
                                        _: 2
                                      }, 1024)
                                    ]),
                                    _: 2
                                  }, 1032, ["disabled", "value", "onUpdate:value"]))
                                : (item.ttype === 'Select')
                                  ? (_openBlock(), _createBlock(_component_a_select, {
                                      key: 2,
                                      options: _unref(creditRulesOptions)[item.OptionEnum] ?? [],
                                      value: item[item.fieldBind],
                                      "onUpdate:value": ($event: any) => ((item[item.fieldBind]) = $event),
                                      onChange: SelectChange,
                                      class: "oio-select component-select",
                                      disabled: !!item.disabled,
                                      style: {"min-width":"220px"},
                                      "dropdown-class-name": "oio-select-dropdown",
                                      placeholder: item.placeholder ?? '请选择'
                                    }, null, 8, ["options", "value", "onUpdate:value", "disabled", "placeholder"]))
                                  : _createCommentVNode("", true)
                          ]),
                          (item.suffix)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_10, _toDisplayString(item.suffix), 1))
                            : _createCommentVNode("", true)
                        ], 2))
                      }), 128))
                    ]))
                  }), 128))
                ]))
              : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})